import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LogTime } from '../../../actions/forFrontEnd_Log';
import dataHandler_alert from '../../../actions/dataHandler_alert';
import ConfigHandler from '../../../actions/ConfigHandler';


export const SpeakTest = (props) => {
    const isVital = ConfigHandler.isVital;
    const { t, i18n } = useTranslation();
    const [content, setContent] = useState(t("ADMIN.SPEAK_TEST.DEFAULT_TEXT"));
    const mos = props.mos;
    const store_beds = useSelector(state => state.store_beds.beds_array);
    const [residentDropdown, setResidentDropdown] = useState(<></>);
    const [padSelect, setPadSelect] = useState(0);
    const [alert, setAlert] = useState(1);
    const [LEVEL, setLEVEL] = useState(1);
    const [RR, setRR] = useState(0);
    let alertlevel = [t("GLOBAL.BED_STATE.LEVEL1"), t("GLOBAL.BED_STATE.LEVEL2"), t("GLOBAL.BED_STATE.LEVEL3")];

    // 當語言改變時更新 content
    useEffect(() => {
        setContent(t("ADMIN.SPEAK_TEST.DEFAULT_TEXT"));
    }, [i18n.language]);

    const alertType = useMemo(() => {
        const baseAlertTypes = [1, 4, 7, 8, 12, 13, 14, 15, 203, 206, 208, 217, 218];
        let allAlertTypes = isVital ? [...baseAlertTypes, 103] : baseAlertTypes;
        return allAlertTypes.sort((a, b) => a - b);
    }, [isVital]);
    useEffect(() => {
        // 處理使用者dropdown
        let _div = residentDropdown
        _div = <select className='w-80 bgC-grey' onChange={e => { setPadSelect(e.target.value) }}>{
            store_beds.map((res, index) => <option key={res.name} value={index}>{res.name}-{res.mac}</option>)
        }</select>
        setResidentDropdown(_div)
    }, [store_beds])
    function sendAlert(_type) {
        let _msg = ''
        let timestamp = new LogTime().getFullTime_withoutMillsec_Ttype()
        switch (_type) {
            case "mwg/events":
                // '{"timestamp": "2022-06-21T16:44:32.599620", "events": {"bedId": "1", "mattressMac": "B8F009B54258", "bedStateAlertLevel": "2", "bedState": "1"}}'
                _msg = `{"timestamp": "${timestamp}", "events": { "bedId": ${store_beds[padSelect].id}, "mattressMac": "${store_beds[padSelect].name}", "bedStateAlertLevel": "${LEVEL}", "bedState": "${alert}"}}`
                break;
            case "mwg/breath":
                _msg = `${store_beds[padSelect].name},${RR}`
                break;
            default:
                break;
        }
        mos.sendPayload(_type, _msg)
    }

    function speak(msg) {
        let u = new SpeechSynthesisUtterance();
        u.lang = i18n.language;
        u.text = msg;
        // u.rate = alertSpeakCount.speed;
        // for(let i=0; i<alertSpeakCount.timeCount; i++){
        speechSynthesis.speak(u);
        // }
    }
    return (<>
        <div className='fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs'>
            <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.SPEAK_TEST.TITLE")}</div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.VOICE_TEST")}</div>
                    <div className='w-40 fx-cspbt'>
                        <input className='bgC-grey br-10 pad-15 l' onChange={e => { setContent(e.target.value) }} value={content} />
                        <img onClick={() => { speak(content) }}
                            className='w-10 speaker cursor-pointer shadow-xs'
                            src={require('../../../assets/images/play-button-arrowhead.png')} />
                    </div>
                </div>
            </div>
        </div>
        {/* alert test */}
        <div className='fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs'>
            <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.SPEAK_TEST.BED_ALERT_TEST.TITLE")}</div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.BED_ALERT_TEST.SELECT_PAD")}</div>
                    <div className='w-40 fx-cspbt'>
                        {residentDropdown}
                    </div>
                </div>
            </div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.BED_ALERT_TEST.ALERT")}</div>
                    <div className='w-40 fx-cspbt'>
                        <select className='w-80 bgC-grey' onChange={e => { setAlert(e.target.value) }} >{
                            alertType.map(res => <option key={res} value={res}>{
                                t(dataHandler_alert(0, res).msg)
                            }</option>)
                        }</select>
                    </div>
                </div>
            </div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.BED_ALERT_TEST.ALERT_LEVEL")}</div>
                    <div className='w-40 fx-cspbt'>
                        <select className='w-80 bgC-grey' onChange={e => { setLEVEL(e.target.value) }} >{
                            [0, 1, 2].map(res => <option key={res} value={res}>{alertlevel[res]}</option>)
                        }</select>
                        <img onClick={() => { sendAlert("mwg/events") }}
                            className='w-10 speaker cursor-pointer shadow-xs'
                            src={require('../../../assets/images/play-button-arrowhead.png')} />
                    </div>
                </div>
            </div>
        </div>

        {/* rr test */}

        <div className='fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs'>
            <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.SPEAK_TEST.BREATHING_TEST.TITLE")}</div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.BREATHING_TEST.SMART_PAD")}</div>
                    <div className='w-40 fx-cspbt'>
                        {residentDropdown}
                    </div>
                </div>
            </div>
            <div className='margl-xs w-100 fx-d-r fx-fsc margt-ss'>
                <div className='fx-d-r font-m w-90'>
                    <div className='w-30 fx-d-c h-100'>{t("ADMIN.SPEAK_TEST.BREATHING_TEST.SELECT_BREATHING_RATE")}</div>
                    <div className='w-40 fx-cspbt'>
                        <input className='w-80 bgC-grey br-10 pad-15 l' type='number' onChange={e => { setRR(e.target.value) }} value={RR} />
                        <img onClick={() => { sendAlert("mwg/breath") }}
                            className='w-10 speaker cursor-pointer shadow-xs'
                            src={require('../../../assets/images/play-button-arrowhead.png')} />
                    </div>
                </div>
            </div>
        </div>

    </>);
}